import {NgModule}             from '@angular/core';
import {CommonModule}         from '@angular/common';
import {ApTranslationModule}  from '../translation/ap-translation.module';
import {ApTooltipModule}      from '../ap-tooltip/ap-tooltip.module';
import {ApPdfViewerComponent} from './ap-pdf-viewer.component';
import {ApDynformsModule}     from '../ap-dynforms/ap-dynforms.module';
import {PdfViewerModule}      from 'ng2-pdf-viewer';
import {ButtonModule}         from '@progress/kendo-angular-buttons';

@NgModule({
  declarations: [
    ApPdfViewerComponent,
  ],
  imports: [
    CommonModule,
    ApTranslationModule,
    ApTooltipModule,
    ApDynformsModule,
    PdfViewerModule,
    ButtonModule,
  ],
  exports: [
    ApPdfViewerComponent,
  ]
})
export class ApPdfViewerModule {
}
